import styled from "styled-components";
import { ReactComponent as SpinnerSvg } from "assets/image/common/Spinner.svg";

const LoadingBackground = styled.div`
    width: 100%;
    height: 100%;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    margin: 1rem 0;
`;
const UploadBackground = styled.div`
    width: 100%;
    height: 100%;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    background-color: rgb(0 0 0 / 20%);
`;
function Loading() {
    return (
        <LoadingBackground>
            <div>Loading...</div>
            <SpinnerSvg style={{margin: 0}} />
        </LoadingBackground>
    );
}

export function UploadLoading() {
    return (
        <UploadBackground>
            <div>Upload...</div>
            <SpinnerSvg style={{margin: 0}} />
        </UploadBackground>
    );
}

export default Loading;